import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableContainer, TableHead, TableRow,
         TableCell, TableBody, Typography, withStyles
} from "@material-ui/core";
import moment from "moment-timezone";
import guid from './../../../../utils/guid';
import NoData from './../../../Common/NoDataRow';
import useStyles from "./tabStyles";
import t from "../../../../languages/pl";
import { displayDateTimeFormat } from './../../../../utils/staticData';

const ZoneTab = props => {
    const { classes, zones } = props;

    const generateRouteDetailsTable = data => {
        if (!data || data.length === 0)
            return <NoData colSpan={4} />;
        return data.map(row => {
            return (
                <TableRow key={guid()}>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {moment.unix(row.data_od).format(displayDateTimeFormat)}
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {moment.unix(row.data_do).format(displayDateTimeFormat)}
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            123 km
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            1:12 h
                        </Typography>
                    </TableCell>
                </TableRow>
            );
        });
    };

    return (
        <TableContainer className={classes.tableContainer}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow >
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.dateFrom}
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.dateTo}
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.kilometerQuantity}
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.timeOutsideTheZone}
                        </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {generateRouteDetailsTable(zones)}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

ZoneTab.propTypes = {
    classes: PropTypes.object,
    zones: PropTypes.array
};

export default withStyles(useStyles)(ZoneTab);
